const texts = {
  title: 'Relatório Anual 2019 | ANBIMA',
  description: '..',
};

export { texts };
